import { render, staticRenderFns } from "./RegionalManagerDashboard.vue?vue&type=template&id=f2420546&"
import script from "./RegionalManagerDashboard.vue?vue&type=script&lang=js&"
export * from "./RegionalManagerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports